namespace GeniuzPOS.Common {
    export interface PIDCardReaderFrom {
        CitizenID: Serenity.StringEditor;
        ThaiFullName: Serenity.StringEditor;
        ThaiTitletName: Serenity.StringEditor;
        ThaiFristName: Serenity.StringEditor;
        ThaiMiddleName: Serenity.StringEditor;
        ThaiLastName: Serenity.StringEditor;
        EnglishName: Serenity.StringEditor;
        EnglishTitleName: Serenity.StringEditor;
        EnglishFirstName: Serenity.StringEditor;
        EnglishMiddleName: Serenity.StringEditor;
        EnglishLastName: Serenity.StringEditor;
        BirthDate: Serenity.DateEditor;
        HouseNo: Serenity.StringEditor;
        VillageNo: Serenity.StringEditor;
        Lane: Serenity.StringEditor;
        Road: Serenity.StringEditor;
        Tambol: Serenity.StringEditor;
        Amphur: Serenity.StringEditor;
        Province: Serenity.StringEditor;
        Sex: Serenity.StringEditor;
        ExpireDate: Serenity.DateEditor;
    }

    export class PIDCardReaderFrom extends Serenity.PrefixedContext {
        static formKey = 'Common.PIDCardReaderFrom';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PIDCardReaderFrom.init)  {
                PIDCardReaderFrom.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DateEditor;

                Q.initFormType(PIDCardReaderFrom, [
                    'CitizenID', w0,
                    'ThaiFullName', w0,
                    'ThaiTitletName', w0,
                    'ThaiFristName', w0,
                    'ThaiMiddleName', w0,
                    'ThaiLastName', w0,
                    'EnglishName', w0,
                    'EnglishTitleName', w0,
                    'EnglishFirstName', w0,
                    'EnglishMiddleName', w0,
                    'EnglishLastName', w0,
                    'BirthDate', w1,
                    'HouseNo', w0,
                    'VillageNo', w0,
                    'Lane', w0,
                    'Road', w0,
                    'Tambol', w0,
                    'Amphur', w0,
                    'Province', w0,
                    'Sex', w0,
                    'ExpireDate', w1
                ]);
            }
        }
    }
}
